<template>
  <section class="ant-layout">
    <main class="ant-layout-content">
      <div class="ant-spin-nested-loading">
        <div class="ant-spin-container">
          <div class="betting-record-page">
            <div class="common-header">
              <font style="vertical-align: inherit"><font style="vertical-align: inherit"> {{ $t('mine.Proxyapplication') }} </font></font>
            </div>

            <div data-v-5a6447c2="" data-v-e37cd8e0="" class="search-options-wrapper">
            <div style="width:600px;padding-top:40px">
                <el-form label-width="180px">
                <el-form-item :label="$t('foot.actual')">
                  <el-input :value="$store.state.userInfo.realname" disabled :placeholder="$t('foot.real')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('foot.number')">
                  <el-input v-model="info.mobile" :placeholder="$t('foot.enterqq')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('foot.Reason')">
                  <el-input type="textarea" v-model="info.apply_info" :placeholder="$t('foot.enter')"></el-input>
                </el-form-item>
                <el-form-item style="display: flex; justify-content: center">
                  <el-button v-if="$store.state.token" type="primary" @click="shenqing">{{ $t('foot.Applications') }}</el-button>
                </el-form-item>
              </el-form>
            </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>
<script>
export default {
  name: 'apply',
  data() {
    return { info: {} };
  },
  created() {
    let that = this;
  },
  methods: {
    shenqing() {
      let that = this;
      that.birthday = $('.ant-picker-input').html();
      let info = that.info;
      let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(info.mobile)) {
        that.$parent.showTost(0, that.$t('foot.correct'));
        return;
      }

      if (!info.apply_info) {
        that.$parent.showTost(0, that.$t('foot.enters'));
        return;
      }

      that.$parent.showLoading();
      that.$apiFun
        .post('/api/applyagentdo', info)
        .then(res => {
          that.$parent.showTost(1, res.message);
          that.$parent.hideLoading();
          that.info = {};
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/betting.css';
.spinner {
  width: 1em;
  height: 1em;
  position: relative;
  font-size: 200px;
  margin: 0 auto;
}

.spinner .line {
  width: 0.15em;
  height: 5px;
  border-radius: 5px;
  background-color: #b5b5b6;
  animation: spinner-line 1s infinite;
  position: absolute;
  right: 0;
  bottom: -0.1em;
}

.spinner svg {
  width: 1.2em;
  height: 1.2em;
  position: absolute;
  top: -0.1em;
  left: -0.1em;
  animation: spinner-jerry-fish 1s infinite;
  z-index: 1;
}

.spinner p {
  width: 100%;
  position: absolute;
  bottom: calc(-0.1em - 40px);
  text-align: center;
  height: 40px;
  line-height: 40px;
  margin: unset;
  display: flex;
  justify-content: center;
}

.spinner p span {
  font-size: 14px;
  color: #c9caca;
}

.spinner .circle {
  width: 1em;
  height: 1em;
  border-radius: 50%;
}

.spinner .circle i {
  position: absolute;
  left: 0;
  clip: rect(0, 1em, 1em, 0.5em);
  width: 1em;
  height: 1em;
  animation: spinner-circle-clipper linear 1s infinite;
}

.spinner .circle i:after {
  position: absolute;
  left: 0;
  clip: rect(0, 1em, 1em, 0.5em);
  width: 1em;
  height: 1em;
  content: '';
  animation: spinner-circle 1s linear infinite;
  border-radius: 50%;
  box-shadow: inset 0 0 0 4px #c9caca;
}

@keyframes spinner-circle-clipper {
  0% {
    transform: rotate(0deg);
  }
  30% {
    transform: rotate(60deg);
  }
  50% {
    transform: rotate(60deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

@keyframes spinner-circle {
  0% {
    transform: rotate(-180deg);
  }
  5% {
    transform: rotate(-170deg);
  }
  30% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(30deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

@keyframes spinner-jerry-fish {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes spinner-line {
  0% {
    opacity: 0;
    right: 0;
  }
  5% {
    opacity: 0.2;
  }
  10% {
    opacity: 0.4;
  }
  15% {
    opacity: 0.6;
  }
  20% {
    opacity: 0.8;
  }
  25% {
    opacity: 1;
  }
  30% {
    opacity: 1;
  }
  35% {
    opacity: 0.8;
  }
  40% {
    opacity: 0.6;
  }
  45% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.3;
  }
  55% {
    opacity: 0.2;
  }
  60% {
    opacity: 0.1;
  }
  65% {
    opacity: 0;
    right: calc(100% - 0.25em);
  }
  100% {
    opacity: 0;
    right: 0;
  }
}
.active {
  color: #fff !important;
}
.ant-table-thead > tr > th {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/apply.vue